export default ({ request }) => ({

  detailDesignElementsCategoryApi (data = {}) {
    return request({
      url: '/digitalCenter/designElementsCategory/detail',
      method: 'post',
      data
    })
  },
  listDesignElementsCategoryApi (data = {}) {
    return request({
      url: '/digitalCenter/designElementsCategory/list',
      method: 'post',
      data
    })
  },
  saveDesignElementsCategoryApi (data = {}) {
    return request({
      url: '/digitalCenter/designElementsCategory/save',
      method: 'post',
      data
    })
  },
  updateStatusDesignElementsCategoryApi (data = {}) {
    return request({
      url: '/digitalCenter/designElementsCategory/updateStatus',
      method: 'post',
      data
    })
  }
})
